import { getChildByType, getChildrenByType } from "react-nanny";

export const getChildByTypeNullable = (
  children: React.ReactNode | null,
  type
) => {
  return children ? getChildByType(children, type) : null;
};

export const getChildrenByTypeNullable = (
  children: React.ReactNode | null,
  type
) => {
  return children ? getChildrenByType(children, type) : null;
};
